import Flussi from "../";

const routes = [
    { name: "FlussiListPage", path: "/flussi", component: Flussi.FlussiListPage, meta: { title: "Flussi" } },
    { name: "FlussiViewPage", path: "/flussi/view/:id", component: Flussi.FlussiViewPage, meta: { title: "Flussi" } },
];
export default routes;
